import { Injectable } from "@angular/core";
import { CanActivate, ActivatedRouteSnapshot, Router } from "@angular/router";
import { AuthService } from "../services/auth.service";

@Injectable({
    providedIn: "root",
})
export class RoleGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const requiredRoles: string[] = route.data["roles"] ?? [];
        const user = this.authService.getCurrentUser();

        if (!user || !requiredRoles.includes(user.user_type)) {
            this.router.navigate(["/dashboard"]);
            return false;
        }

        return true;
    }
}
